/**
 * The year's prepaid-voucher sales with their VAT (#3261) — the list the
 * year-end VAT correction is made from. Pure apart from the cell escaping, so
 * it is testable; built from the JSON `/admin/voucher/sales` returns, as the
 * other admin exports are.
 */

import { escapeCSVField } from './csvFieldEscape';
import { VoucherSalesReport } from '../api/voucher/voucherApiTypes';

export interface VoucherSalesCsvLabels {
    date: string;
    code: string;
    gross: string;
    currency: string;
    vatCountry: string;
    vatRate: string;
    vatAmount: string;
    refunded: string;
    status: string;
    /** For a cell with no value — VAT not recorded. */
    missing: string;
    statusLabel: (status: VoucherSalesReport['rows'][number]['status']) => string;
}

/** Decimal comma, as German Excel reads a number. */
const amount = (n: number): string => n.toFixed(2).replace('.', ',');

export const buildVoucherSalesCsv = (report: VoucherSalesReport, labels: VoucherSalesCsvLabels): string => {
    const header = [
        labels.date, labels.code, labels.gross, labels.currency, labels.vatCountry,
        labels.vatRate, labels.vatAmount, labels.refunded, labels.status,
    ];
    const lines = report.rows.map((r) => [
        r.purchasedOn,
        r.code ?? labels.missing,
        amount(r.gross),
        r.currency ?? labels.missing,
        r.vatCountry ?? labels.missing,
        r.vatRate === null ? labels.missing : amount(r.vatRate),
        r.vatAmount === null ? labels.missing : amount(r.vatAmount),
        amount(r.refundedAmount),
        labels.statusLabel(r.status),
    ]);
    return [header, ...lines].map((cells) => cells.map(escapeCSVField).join(';')).join('\n');
};

export const voucherSalesCsvFileName = (label: string, year: string): string => `${label}-${year}.csv`;
